export default 'M3.5 7.5a1.5 1.5 0 1 0 0 3h17a1.5 1.5 0 0 0 0-3zm0 6a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3z';